import { render, staticRenderFns } from "./AdUnit.vue?vue&type=template&id=8c145622&scoped=true&"
import script from "./AdUnit.vue?vue&type=script&lang=js&"
export * from "./AdUnit.vue?vue&type=script&lang=js&"
import style0 from "./AdUnit.vue?vue&type=style&index=0&id=8c145622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c145622",
  null
  
)

export default component.exports